import _ from 'lodash';

import Gopher from './assets/gopher.png';
import NodeJS from './assets/nodejs.png';
import Business from './assets/business.png';
import Debug from './assets/debug.png';

const types = [
    {
        name: 'Golang',
        picture: Gopher,
    },
    {
        name: 'Node.JS',
        picture: NodeJS,
    },
    {
        name: 'Business',
        picture: Business,
    },
    {
        name: 'Debug',
        picture: Debug,
    },
];

function findByName(name) {
    return _.find(types, function(o) { return _.toLower(o.name) === _.toLower(name); });
}
export function GetTagPicture(name) {
    const choosen = findByName(name);
    if (_.isUndefined(choosen)) {
        return '';
    }
    return choosen.picture;
}

export function GetLink(name) {
    return `/tags/${_.kebabCase(name)}`;
}


// WEBPACK FOOTER //
// ./src/tags/chooser.js